import { Component, ViewChild, ElementRef } from '@angular/core';
import lottie from 'lottie-web';
import animationData from './animationData';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: false,
})
export class SpinnerComponent {
  @ViewChild('refSpinner', { static: true }) nameRefSpinner: ElementRef;

  constructor() {}

  ngOnInit() {
    this.initAnimation();
  }

  styleSpinner() {
    let styles = {
      width: '90px',
      height: '90px',
    };
    return styles;
  }

  initAnimation() {
    lottie.loadAnimation({
      container: this.nameRefSpinner.nativeElement,
      renderer: 'svg',
      animationData,
      loop: true,
    });
  }
}
